export class UnexpectedError extends Error {
  data?: any;

  constructor(data?: any) {
    super('Algo de errado aconteceu. Tente novamente em breve.');
    this.name = 'UnexpectedError';
    this.data = data;
  }
}
